import React,{useEffect ,useState} from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardHeader from "./DashboardHeader";
import Navbar from "./Navbar";


const ApplicationInstructions = () => {
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        const now = new Date();
        fetch(`${process.env.REACT_APP_BASE_URL_strapi}/msec-applications-schedules?filters[applications_is_active][$eq]=true&filters[applications_start_date][$lte]=${now.toISOString()}&filters[applications_end_date][$gte]=${now.toISOString()}`)
          .then(res => res.json())
          .then(data => {
            if (data.data && data.data.length > 0) {
              setEndDate(data.data[0].attributes.applications_end_date);
            }
          })
          .catch(err => console.error('Error fetching application schedule:', err));
      }, []);

    const navigate = useNavigate();
    return (

      


        <div>
            {/* Header Start */}
            <div className="mb-5">

                <DashboardHeader />
            </div>
            <div className="container row justify-content-center m-auto mb-5">
                <div className="col-md-10">
                    <div className="row justify-content-center">
                        <div className="col-sm-12 col-md-4">
                            <Navbar />
                        </div>
                        <div className="col-sm-12 col-md-8 mb-4">
                            <div className="card application-instructions-card">
                                <div className="card-body">
                                <div className="card-body application-instructions-card-body">
                                    <div className="alert alert-warning mb-4" role="alert" style={{ backgroundColor: "#70bf6a", color: "#ffffff", border: "none" }}>
                                        <strong>Do Not Use AI:</strong> Use of AI tools is discouraged - we want to hear your authentic perspectives and original ideas. While AI can be a helpful tool, we value personal insights, creativity, and real-world experiences in your application.
                                    </div>
                                    <h1>Instructions</h1>
                                    <p>Welcome! You have successfully started an application for <strong>Margalla School on Energy and Climate (MSEC) powered by Renewables First.</strong></p>
                                    <p>Thank you for your interest in the program. We look forward to receiving your completed application.</p>

                                    <h5><strong>Key Dates:</strong></h5>
                                    <ul>
                                        <li><strong>Application deadline: </strong>
                                        {endDate ? (
                                          <>
                                            {new Date(endDate).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}, at 11:59 PM (PKT)
                                          </>
                                        ) : (
                                          <span>Please check back for updates.</span>
                                        )}

                                         </li>
                                        <li><strong>Final Decisions:</strong> December 2026</li>
                                        <li><strong>Two-week Fellowship starts:</strong> January 04, 2027 – January 15, 2027 in Islamabad </li>
                                    </ul>

                                    <h5><strong>Important Notes:</strong></h5>
                                    <ul>
                                        <li>Complete all sections of the application before the deadline.</li>
                                        <li>Use of AI tools is discouraged - we want to hear your authentic perspectives and original ideas. While AI can be a helpful tool, we value personal insights, creativity, and real-world experiences in your application.</li>
                                        <li>No extensions or late applications will be accepted.</li>
                                        <li>You can save your progress and return to complete sections later.</li>
                                        <li>Review all information carefully before final submission.</li>
                                        <li>Use the "Continue" button at the bottom of each page to save and advance.</li>
                                        <li>Before submitting, ensure all sections are complete and accurate.</li>

                                    </ul>

                                    <p>For any questions, contact us at <a href="mailto:msec@renewablesfirst.org">msec@renewablesfirst.org</a>.</p>
                                    <p>Click the "Continue" button to begin your application.</p>
                                    </div>


                                </div>
                                <div className="card-footer">
                                    <div className="mc-footer">
                                        <div className="row text-center">
                                            <div className="col-lg-12 ">
                                                <button type="button" className="btn btn-primary m-1 text-white application-instructions-btn" onClick={() => navigate('/application/personal-information')}>
                                                    Continue
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ApplicationInstructions;

